export const LOADING_COLLABORATOR_TYPE = "LOADING_COLLABORATOR_TYPE";
export const SAVE_LOADING_COLLABORATOR_TYPE = "SAVE_LOADING_COLLABORATOR_TYPE";
export const GET_COLLABORATOR_TYPE = "GET_COLLABORATOR_TYPE";
export const FORM_FAIL = "FORM_FAIL";
export const COLLABORATOR_TYPE_FAIL = "COLLABORATOR_TYPE_FAIL";
export const LOADING_COLLABORATOR_TYPE_BY_ID = "LOADING_COLLABORATOR_TYPE_BY_ID";
export const GET_COLLABORATOR_TYPE_BY_ID = "GET_COLLABORATOR_TYPE_BY_ID";